import log from 'loglevel'

/**
 * Calculate available ranges based on a list of available days
 *
 * @param {Array} availableDays
 */
export function getValidRanges (availableDays) {
  // Checks if the given range expression is valid (can be extended to do a more in-depth check)
  const isValidRangeExpression = expression => expression.split(':').length == 2
  // Convert a string 'x:y' to an object { a: x, b: y }
  const rangeToObject = range => {
    const parts = range.split(':')
    return { a: parts[0], b: parts[1] }
  }
  // Convert an object { a: x, b: y } to string 'x:y'
  const objectToRange = range => `${range.a}:${range.b}`
  // Checks if the given object in form of { a: x, b: y } has:
  //   a >= than any of the options
  //   b <= than any of the given options
  const isValidRange = options => range =>
    options.some(option => option >= range.a && option <= range.b)

  // Converts given options to numeric values
  const numericOptions = availableDays.map(option => parseInt(option))

  // Gets available ranges
  const ranges = '1:5,6:9,10:13,14:16,1:16'
    .split(',')
    .map(range => range.trim())
    .filter(isValidRangeExpression)
    .map(rangeToObject)
    .filter(isValidRange(numericOptions))
    .map(objectToRange)

  log.debug('DateSelect.setAvailableOptions - filtered options', ranges)

  return ranges
}



// WEBPACK FOOTER //
// ./src/utils/getValidRanges.js